const { addPaymentButton } = require("./types/add-payment-btn");
const { insertSliderValues } = require("./types/add-slider-value");
const { closedPanels } = require("./types/panels-closed");
const { paymentMsgExpand } = require("./utils/expand-paymnt-msg");
const { progressBarClassChange } = require("./utils/progress-bar-classes");
const { scrollToTop } = require("./utils/scroll-top");
const { sendEmailSuccessMessage } = require("./utils/send-email-success");
const { sendPaymentLink } = require("./utils/send-payment-link");

function handleRakProcessStep() {
    function stepChangeFunctions() {
        console.log("processStepChange functions triggered");
        progressBarClassChange();
        scrollToTop();
        insertSliderValues();
        addPaymentButton();
        paymentMsgExpand();
        sendEmailSuccessMessage();
        sendPaymentLink();
        closedPanels();
    }

    document.addEventListener("processStepChanged.skye", stepChangeFunctions, false);
}

handleRakProcessStep();